import React from 'react';
import { useState } from "react";
import * as FaIcons from "react-icons/fa";
import { Button, Modal, Container, Row, Col, FormControl, FormLabel } from 'react-bootstrap';
import MessageBox from './MessageBox';
import { useEffect } from 'react';

import MaterialBrandsDataService from './services/materialbrand.service';
import MaterialColorsDataService from './services/materialcolor.service';

function NewEditDoor(props) { 
  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);
  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');

  const [lgShow, setLgShow] = useState(false);
	const [qty,setQty] = useState('');
  const [width,setWidth] = useState('');
  const [height,setHeight] = useState('');  
  const [producttype,setProductType] = useState({});
  const [materialbrand,setMaterialBrand] = useState({});
  const [materialcolor,setMaterialColor] = useState({});
	const [doorstyle,setDoorStyle] = useState({});
	const [hingeBorring,setHingeBorring] = useState(0);

  const [materialbrands, setMaterialbrands] = useState([]);
  const [materialcolors, setMaterialcolors] = useState([]);

  const [sorttype, setSorttype] = useState('ASC');
  const [sortfield, setSortfield] = useState('id');  
  //const [doors, setDoors] = useState([]);
  const [door, setDoor] = useState({});  

  const mode = props.mode;  
  const doorsmode = props.doorsmode;  // 0 -> new door, 1 -> edit door
  const addeditems = props.addeditems;
  const editItem = props.editItem;
  const doorsArrayFunction = props.doorsArrayFunction;
  
  const producttypes = props.producttypes;
  const doorstyles = props.doorstyles;  

  const onChangeDoorQty = (e) => {
    setQty(e.target.value);
  }

  const onChangeWidth = (e) => {
    setWidth(e.target.value);
  }
  
  const onChangeHeight = (e) => {
    setHeight(e.target.value);
  }  
  const onChangeProductType = (e) => {
    setProductType(producttypes.find(item => item.id === parseInt(e.target.value)));
    console.log(producttypes);
    //setHingeBorring(1); it didn't work
  }

  const onChangeDoorStyle = (e) => {
    setDoorStyle(doorstyles.find(item => item.id === parseInt(e.target.value)));
  }  

  const onChangeHingeBorring = (e) => {
    setHingeBorring(e.target.value);
  }

  const onChangeMaterialBrand = (e) => {
    setMaterialBrand(materialbrands.find(item => item.id === parseInt(e.target.value))); 
  }
  
  const onChangeMaterialColor = (e) => {
    setMaterialColor(materialcolors.find(item => item.id === parseInt(e.target.value)));
  }

  const handleClose = () => {
    if (props.doorsmode === 1) {

    }
    else {
      setMaterialBrand({});
      setQty('');
      setWidth('');
      setHeight('');
      setProductType({});
      setMaterialColor({});
      setDoorStyle({});
      setHingeBorring('');
    }
    setLgShow(false);    
    
  }

  const handleShow = () => {    
    console.log(props);
    if (props.doorsmode === 0) {
      if (props.materialbrand.id !== undefined && props.materialcolor.id !== undefined) {
        // Apply this to the SearchClient and test:
        setLgShow(true);    
        setSortfield('id');
        setSorttype('ASC');   
        setMaterialBrand(props.materialbrand);       
        setMaterialColor(props.materialcolor);       
      }
      else {
        props.setErrmessage("Please, select a brand and a color before adding doors.");
        props.setShowerror(true);
      }  
    }
    else {
      setLgShow(true);    
      setSortfield('id');
      setSorttype('ASC');   
      setMaterialBrand(props.door.brand);  
      setMaterialColor(props.door.color);        
      setProductType(props.door.producttype);         
      setDoorStyle(props.door.doorstyle);         
          
    }
  }

  const onSaveDoor = () => {   
    const new_door = {
      doorqty: qty,
      doorwidth: width,
      doorheight: height,
      producttype: producttype,
      brand: materialbrand,
      color: materialcolor,
      doorstyle: doorstyle,
      hingeborring: hingeBorring,
      // you can send custom parameters for door calculation like this:
      /*
      doorcalculation: [{
        processing_routing_sqft:5,
        processing_eb_sqft:3,
        processing_assembly_sqft:2,
        sqft_markup_cq:6,
        milling_sqft_shaker_plus_only: doorstyle===4 ? 5 : 0, // 4 is shaker plus style
        hinge_bore_param:9
      }]
      */
    };
    
    console.log(!qty);
    console.log(!width);
    console.log(!height);
    console.log(Object.keys(producttype).length===0);
    console.log(Object.keys(materialbrand).length===0);
    console.log(Object.keys(materialcolor).length===0);
    console.log(Object.keys(doorstyle).length===0);
    console.log(!(parseInt(hingeBorring)===0 || parseInt(hingeBorring)===1));
    console.log(hingeBorring);
    console.log(props.doorsmode);
    
  
    if (!qty || 
      !width || 
      !height || 
      Object.keys(producttype).length===0 || 
      Object.keys(materialbrand).length===0 || 
      Object.keys(materialcolor).length===0 || 
      Object.keys(doorstyle).length===0 || 
      !(parseInt(hingeBorring)===0 || parseInt(hingeBorring)===1)) {
      setShowerror(true);
      setErrmessage('Fields can not be empty.');      
      return;
    }
    if (props.doorsmode === 1) {
      new_door.versionid = door.fastquotingdoorversionId;
      console.log(props);
      editItem(props.index, new_door);
    }
    else if (props.doorsmode === 0) {
      doorsArrayFunction(addeditems, new_door);
    }
    


    handleClose();
  }

  useEffect(() => {
    console.log("product type changed to " + JSON.stringify(producttype));
    if (producttype) {
      if(parseInt(producttype.id) === 1) {

      }
      else {      
        setHingeBorring(0);
      }
    }
    else {
      setHingeBorring(0);
    }
  },[producttype]);

  useEffect(() => {
    console.log(props);
    MaterialBrandsDataService.getAll()
    .then(resp => {
      console.log(resp.data);
      setMaterialbrands(resp.data);
    })
    .catch(err => {
      console.log(err);
      setShowerror(true);
      setErrmessage(err.message || "An unknown error occurred.");
    });  
    //setMaterialColor({});           


    if (mode === 0) { // create
      setDoor({});
    }
    else if (mode === 1) {// edit

    }
    else if (mode === 2) {// view

    }    

    if (props.doorsmode === 1) {  
      setDoor(props.door);
      setQty(props.door.doorqty);
      setHeight(props.door.doorheight);
      setWidth(props.door.doorwidth);
      setProductType(props.door.producttype);
      setDoorStyle(props.door.doorstyle);
    }
    else if (props.doorsmode === 0) {
      //setProductType({});
      //setDoorStyle({});
      //setProductType(producttypes.find(ptype => ptype.id === parseInt(props.door.producttype.id)));
      //setDoorStyle(doorstyles.find(dstyle => dstyle.id === parseInt(props.door.doorstyle.id)));
    }

  },[]);

  
  useEffect(() => {
    console.log(materialbrand);
    MaterialColorsDataService.getByMaterialBrand(materialbrand.id)
    .then(resp => {
      console.log(resp.data);
      setMaterialcolors(resp.data);
      //setMaterialColor({});
    })
    .catch(err => {
      console.log(err);
    });       
  },[materialbrand]);
  

    return (
      <>
        <Button 
          disabled={mode===2} 
          lg={8} 
          style={{maxWidth:"100px",maxHeight:'38px'}} 
          variant="primary" 
          onClick={handleShow}
        >
          {props.doorsmode===0?"Add Door":"Edit Door"}</Button>      
        <Modal
          size="lg"
          show={lgShow}          
          onHide={handleClose}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {'New Door'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>

              <div className="d-flex justify-content-start flex-wrap">
                <div className="m-1">
                  <label className="mr-5" htmlFor="description">Door Qty:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="doorqty"
                    id="doorqty"
                    onChange={onChangeDoorQty}
                    defaultValue={door.doorqty}/>
                </div>                       
                <div className="m-1">
                  <label className="mr-5" htmlFor="description">Door Width (in):</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="doorwidth"
                    id="doorwidth"
                    onChange={onChangeWidth}
                    defaultValue={door.doorwidth}
                  />
                </div> 
                <div className="m-1">
                  <label className="mr-5" htmlFor="email">Door Height (in):</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="doorheight"
                    id="doorheight"
                    onChange={onChangeHeight}
                    defaultValue={door.doorheight}
                    />
                </div>                                             
                <div className="m-1">
                  <label className="mr-5" htmlFor="email">Product Type:</label>
                  <select 
                    defaultValue={props.door?props.door.producttype.id:null} 
                    onChange={onChangeProductType} 
                    className="form-control" 
                    id="producttype" 
                    name="producttype" 
                    disabled={mode===2}
                  >
                    <ListOfProductTypes producttypes={producttypes}/>       
                  </select>                 
                </div>    

                <div className="m-1">
                  <label className="mr-5" htmlFor="email">Brand:</label>
                  <select 
                    //value={door?door.materialbrand:0} 
                    defaultValue={materialbrand.id} 
                    onChange={onChangeMaterialBrand} 
                    className="form-control" 
                    id="materialbrand" 
                    name="materialbrand" 
                    disabled={true}>
                    <ListOfMaterialBrands materialbrands={materialbrands}/>       
                  </select>                 
                </div>                             

                <div className="m-1">
                  <label className="mr-5" htmlFor="email">Color:</label>
                  <select 
                    style={{minWidth:"400px"}} 
                    //defaultValue={door?door.materialcolor:0} 
                    value={materialcolor.id} 
                    onChange={onChangeMaterialColor} 
                    className="form-control" 
                    id="materialcolor" 
                    name="materialcolor" 
                    disabled={true}>
                    <ListOfMaterialColors materialcolors={materialcolors} materialcolor={materialcolor}/>       
                  </select>                 
                </div>     

                <div className="m-1">
                  <label className="mr-5" htmlFor="email">Door Style:</label>
                  <select 
                    defaultValue={props.door?props.door.doorstyle.id:0} 
                    onChange={onChangeDoorStyle} 
                    className="form-control" 
                    id="doorstyle" 
                    name="doorstyle" 
                    disabled={mode===2}
                  >
                    <ListOfDoorStyles doorstyles={doorstyles}/>       
                  </select>                 
                </div>   

                <div className="m-1">
                  <label className="mr-5" htmlFor="email">Hinge Borring:</label>
                  <select 
                    value={hingeBorring} // change to defaultValue under your own risk
                    onChange={onChangeHingeBorring} 
                    className="form-control" 
                    id="hingeborring" 
                    name="hingeborring" 
                    disabled={(mode===2) || producttype?producttype.id !== 1:true} //|| producttype.id !== 1 
                  >
                    <option key={-1} disabled selected value={-1}>{"Select"}</option>
                    <option key={0} value={0}>{"No"}</option>
                    <option key={1} value={1}>{"Yes"}</option>
                  </select>                 
                </div>                 

              </div>
              <hr/>
              <div className="m-1 d-flex justify-content-start flex-wrap">              
                <Button onClick={onSaveDoor}>
                  Save Door
                </Button>            
              </div>    

              <Row className='mt-2'>

                {showerror && (
                  <MessageBox show={true} showerror={showerror} errmessage={errmessage}
                    onHide={() => {
                      setShowerror(false)
                    }}
                  />
                )}
                {showsuccess && (

                  <MessageBox show={true} showsuccess={showsuccess} succmessage={succmessage}
                    onHide={() => {
                    setShowsuccess(false);
                    window.location.reload();
                  }}
                  />
                )}

              </Row> 
            </Container>

          </Modal.Body>
        </Modal>
      </>
    );
}

const ListOfMaterialBrands = (props) => {
  if (!props.materialbrands) {
    return 
  }
  const rows = props.materialbrands.map((row, index) => {
    return (  
      <option key={index} value={row.id}>        
        {row.materialbrandname}
      </option>
    )
  })  
  return (      
    <>        
    <option disabled value={-1} selected>
      {"Select"}
    </option>
    {rows}
    </>
  )
}

const ListOfMaterialColors = (props) => {
  if (!props.materialcolors) {
    return 
  }
  const rows = props.materialcolors.map((row, index) => {
    return (  
      <option key={index} value={row.id}>        
        {row.materialcolorname}
      </option>
    )
  })  
  return (      
    <>       
    <option disabled value={-1}>
      {"Select"}
    </option>
    {rows}
    </>
  )
}  

const ListOfProductTypes = (props) => {
  if (!props.producttypes) {
    return 
  }
  const rows = props.producttypes.map((row, index) => {
    return (  
      <option key={index} value={row.id} selected={props.defaultValue == row.id}>        
        {row.producttype}
      </option>
    )
  })  
  return (      
    <>        
    <option disabled selected={props.defaultValue == null}>
      {"Select"}
    </option>
    {rows}
    </>
  )
}  

const ListOfDoorStyles = (props) => {
  if (!props.doorstyles) {
    return 
  }
  const rows = props.doorstyles.map((row, index) => {
    return (  
      <option key={index} value={row.id} selected={Object.keys(props.doorstyles).length === 0}>        
        {row.doorstyle}
      </option>
    )
  })  
  return (      
    <>        
    <option disabled selected={props.defaultValue == null}>
      {"Select"}
    </option>
    {rows}
    </>
  )
}  
  
export default NewEditDoor;